// extracted by mini-css-extract-plugin
export default {"container":"OfferFormSortingOptions_container__MwKVC"};